import { render, staticRenderFns } from "./apartments-overview-info.vue?vue&type=template&id=6a1dd2ad&scoped=true&"
import script from "./apartments-overview-info.ts?vue&type=script&lang=ts&"
export * from "./apartments-overview-info.ts?vue&type=script&lang=ts&"
import style0 from "./apartments-overview-info.scss?vue&type=style&index=0&id=6a1dd2ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1dd2ad",
  null
  
)

export default component.exports